import {FormControl, FormField} from 'platform/components';
import {Box} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {TASK_TYPES} from '../constants/TASK_TYPES';
import {DocumentExtractionImportFormDefinition} from '../types/DocumentExtractionImportFormDefinition';
import {DocumentExtractionImportFileField} from './DocumentExtractionImportFileField';

interface DocumentExtractionImportFormFieldsProps extends RequiredTestIdProps {
  control: FormControl<DocumentExtractionImportFormDefinition>;
  formApi: UseFormReturn<DocumentExtractionImportFormDefinition>;
}

export function DocumentExtractionImportFormFields(props: DocumentExtractionImportFormFieldsProps) {
  return (
    <>
      <Box width="100%" data-testid={props['data-testid']}>
        <FormField
          isDisabled
          isRequired
          isNotClearable
          control={props.control}
          name="taskType"
          type="choice"
          label={i18n.t('entity.documentExtraction.labels.taskType')}
          options={taskTypeOptions}
          data-testid={suffixTestId('inputs.taskType', props)}
        />
      </Box>
      <DocumentExtractionImportFileField
        name="filesToImport"
        control={props.control}
        formApi={props.formApi}
        data-testid={suffixTestId('inputs.filesToImport', props)}
      />
    </>
  );
}

const taskTypeOptions = [
  {
    label: i18n.t('entity.documentExtraction.labels.extractDeliveryNote'),
    value: TASK_TYPES.extractDeliveryNote,
  },
];
